import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { dispatch, select } from '@ngxs/store';
import { ChatService } from '../../services/chat.service';
import { chatOpenConversationsList } from '../../state/chat.actions';
import { ChatState } from '../../state/chat.state';

@Component({
  selector: 'app-chat-header-button',
  imports: [MatIconButton, MatBadge, MatIcon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './chat-header-button.component.html'
})
export class ChatHeaderButtonComponent implements OnInit {
  readonly #chatService = inject(ChatService);
  public readonly unseenMessagesCount = select(ChatState.unseenMessagesCount);

  public onOpenConversationsList = dispatch(chatOpenConversationsList);

  ngOnInit() {
    this.#chatService.init();
  }
}
